
import { type FC, useCallback, useState } from 'react';
import {
  uiStyles,
  type UiStackProps,
  UiStack,
  UiGrid,
  UiText,
  UiMenu,
  UiMenuButton,
  UiIconCaretDown,
  UiMenuList,
  UiMenuItem,
  UiButton, UiHStack, UiBox,
} from '@/lib/ui';
import { useLocale } from '@/registration/component/Locale/LocaleProvider';
import { IconButton, useDisclosure } from '@chakra-ui/react';
import { LocaleData } from '@/api/registration';
import LocaleSwitchConfirmation from '@/registration/component/Locale/LocaleSwitchConfirmation';

export interface LocaleSwitchProps extends UiStackProps {
  tenantCode: string,
  eventId: string,
  isGroup?: boolean,
}

const LocaleSwitch: FC<LocaleSwitchProps> = ({
  tenantCode,
  eventId,
  isGroup = false,
  ...props
}) => {
  const {currentLocale, localeList} = useLocale();
  const [toLocale, setToLocale] = useState<LocaleData|null>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const onLocaleChangeAttempt = useCallback((locale: LocaleData)=> {
    if (locale.id !== currentLocale?.id) {
      setToLocale(locale);
      onOpen();
    }
  }, [
    currentLocale,
    setToLocale,
    onOpen,
  ]);

  // For now, we do not show anything if no locale is found due to whatever reason.
  // This should never happen since the rego won't be properly setup without any locale.
  if (!currentLocale || localeList.length === 0 ) {
    return null;
  }

  // The event only has one locale, show nothing.
  if (localeList.length === 1) {
    return null;
  }

  return (
    <>
      <UiHStack
        alignItems={'stretch'}
        // borderRadius={uiStyles.borderRadius}
        // borderWidth={'1px'}
        // borderColor={'gray.300'}
        // borderStyle={'solid'}
        // px={{base:4, lg: 6}}
        // py={0}
        // spacing={4}
        {...props}
      >
        <UiMenu>
          <UiMenuButton
            as={UiButton}
            // borderRadius={uiStyles.borderRadius}
            rightIcon={<UiIconCaretDown color={'text.primary'} size={'20px'} weight={'bold'}/>}
            color={'text.primary'}
            bgColor={'#fff'}
            borderWidth={'2px'}
            borderColor={'gray.600'}
            borderStyle={'solid'}
            fontSize={'md'}
            // minW={150}
            // maxW={150}
            textAlign={'left'}
            _expanded={{
              bgColor: '#fff',
            }}
            px={{base: 4, lg: 8}}
          >
            {`${currentLocale.currency}`}
          </UiMenuButton>
          <UiMenuList
            // borderRadius={uiStyles.borderRadius}
            // borderColor={'primary.300'}
            shadow={uiStyles.cardShadow}
          >
            {localeList.map((lo) => {
              if (lo.id !== currentLocale.id) {
                return (
                  <UiMenuItem
                    key={lo.id}
                    onClick={() => {onLocaleChangeAttempt(lo);}}
                  >
                    <UiText px={4}>{lo?.currency}</UiText>
                  </UiMenuItem>
                );
              }
            })}
          </UiMenuList>
        </UiMenu>
      </UiHStack>
      {!!toLocale && (
        <LocaleSwitchConfirmation
          tenantCode={tenantCode}
          eventId={eventId}
          toLocale={toLocale}
          isOpen={isOpen}
          onClose={onClose}
          isGroup={isGroup}
        />
      )}
    </>
  );
};

export default LocaleSwitch;
